import * as Yup from 'yup';
var sportEventSettingsValidationSchema = Yup.object().shape({
    startDate: Yup.date().required('Не указана дата начала события.').typeError('Неверный формат даты.'),
    endDate: Yup.date().required('Не указана дата окончания события.').typeError('Неверный формат даты.'),
    registrationStartDate: Yup.date().required('Не указана дата окончания события.').typeError('Неверный формат даты.'),
    registrationEndDate: Yup.date().required('Не указана дата окончания события.').typeError('Неверный формат даты.')
});
export default sportEventSettingsValidationSchema;
